import * as commonConst from 'app/constants/commons';
import { GlobalData } from 'types/commons';
import { User } from 'types/auth';

export const setLoading = (loading: boolean) => ({
    type: commonConst.SET_LOADING,
    payload: loading
});

export const setAuthentication = (user: User) => ({
    type: commonConst.SET_USER_LOGIN,
    payload: user
});

export const setGlobalData = (data: GlobalData) => ({
    type: commonConst.SET_GLOBAL_DATA,
    payload: data
});
